import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isValidPhoneNumber } from 'libphonenumber-js';

/**
 * Phone number custom validator
 */
export function PhoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    if (isValidPhoneNumber(control.value)) {
      return null;
    }

    return {invalidPhoneNumber: true};
  };
}
